/* Twentyseven · Meta-exclusive free gift: cart progress bar + auto-added gift. Config + visitor check live in snippets/t27-meta-gift.liquid. */
(function () {
  var G = window.T27Gift;
  if (!G) return;

  var busy = false, queued = false;

  function money(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(cents, G.moneyFormat);
    return '$' + (cents / 100).toFixed(2);
  }
  function isGift(item) { return item.properties && item.properties._t27_gift; }
  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function getCart() { return fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

  function rebuild() { document.dispatchEvent(new CustomEvent('cart:build')); }

  /* Keep the gift line in step with the cart: in at $150+, out below it, never more than one. Non-Meta carts lose any stray gift. */
  function sync() {
    if (busy) { queued = true; return; }
    busy = true;
    getCart().then(function (cart) {
      var gifts = cart.items.filter(isGift);
      var spend = cart.items.reduce(function (s, i) { return isGift(i) ? s : s + i.final_line_price; }, 0);
      var qualifies = G.active && !unavailable() && spend >= G.threshold;
      var job = null;
      if (qualifies && gifts.length === 0) {
        job = post('/cart/add.js', { items: [{ id: G.variantId, quantity: 1, properties: { _t27_gift: 'Meta holiday gift' } }] })
          .then(function (res) { if (res && res.status) { markUnavailable(); render(spend, false); } return res; });
      } else if (gifts.length && (!qualifies || gifts.length > 1 || gifts[0].quantity > 1)) {
        var updates = {};
        gifts.forEach(function (g, n) { updates[g.key] = qualifies && n === 0 ? 1 : 0; });
        job = post('/cart/update.js', { updates: updates });
      }
      render(spend, gifts.length > 0 && qualifies);
      if (job) return job.then(function (res) { if (!(res && res.status)) rebuild(); }, function () {});
    }).catch(function () {}).then(function () {
      busy = false;
      if (queued) { queued = false; sync(); }
    });
  }

  /* Progress bar at the top of the cart pop-out (and cart page). */
  /* Sold out or not on the Online Store: switch the offer off for this visit, so nobody is promised a gift that can't ship. */
  function unavailable() { if (G.preview) return false; try { return sessionStorage.getItem('t27_gift_unavailable') === '1'; } catch (e) { return false; } }
  function markUnavailable() {
    if (G.preview) { console.warn('[T27Gift] gift could not be added (is the sock on the Online Store?)'); return; }
    try { sessionStorage.setItem('t27_gift_unavailable', '1'); } catch (e) {}
    document.documentElement.classList.remove('t27-gift-on');
  }

  function render(spend, hasGift) {
    document.querySelectorAll('form [data-products]').forEach(function (products) {
      var form = products.closest('form');
      var el = form.querySelector('.t27-gift-progress');
      if (!G.active || unavailable() || spend <= 0) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('div');
        el.className = 't27-gift-progress';
        products.parentNode.insertBefore(el, products);
      }
      var left = G.threshold - spend;
      if (left > 0) {
        var pct = Math.max(4, Math.min(100, Math.round(spend / G.threshold * 100)));
        el.classList.remove('is-unlocked');
        el.innerHTML =
          '<div class="t27-gift-progress__body">' +
            '<p class="t27-gift-progress__msg">You’re <strong>' + money(left) + '</strong> away from a <strong>free holiday gift</strong></p>' +
            '<div class="t27-gift-progress__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="Progress to the free gift"><div class="t27-gift-progress__fill" style="width:' + pct + '%"></div></div>' +
            '<span class="t27-gift-progress__note">' + G.title + ', free on orders over ' + money(G.threshold).replace(/\.00$/, '') + '</span>' +
          '</div>' +
          '<img class="t27-gift-progress__img" src="' + G.image + '" alt="' + G.title + '" width="54" height="60" loading="lazy">';
      } else {
        el.classList.add('is-unlocked');
        el.innerHTML =
          '<p class="t27-gift-progress__msg"><svg width="14" height="14" viewBox="0 0 24 24" fill="#7A1F2B" aria-hidden="true"><path d="M12 2l1.8 6.2L20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8z"/></svg><span>You’ve unlocked a <strong>free holiday gift</strong>.' + (hasGift ? ' It’s in your cart.' : '') + '</span></p>' +
          '<div class="t27-gift-progress__track" role="img" aria-label="Free gift unlocked"><div class="t27-gift-progress__fill" style="width:100%"></div></div>';
      }
    });
  }

  /* Re-run whenever the theme redraws the cart items. */
  function watch() {
    document.querySelectorAll('[data-products]').forEach(function (node) {
      if (node.__t27) return;
      node.__t27 = true;
      new MutationObserver(function () { sync(); }).observe(node, { childList: true });
    });
  }

  function init() {
    if (unavailable()) document.documentElement.classList.remove('t27-gift-on');
    watch();
    sync();
    document.addEventListener('ajaxProduct:added', sync);
    document.addEventListener('cart:updated', sync);
    document.addEventListener('CartDrawer:open', sync);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
